<template>
  <div>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            자택주소
            <span class="asterisk">*</span>
          </v-list-item-title>
          <v-text-field
            placeholder="우편번호 검색"
            ref="refZipcode"
            solo
            readonly
            :height="formHeight"
            required
            v-model="userData.address.zipcode"
            @click="$emit('openSearch')"
          >
            <template v-slot:append>
              <v-btn x-small depressed rounded @click="$emit('openSearch')">
                우편번호</v-btn
              >
            </template>
          </v-text-field>
          <v-text-field
            placeholder="주소"
            ref="refCity"
            solo
            readonly
            :height="formHeight"
            required
            v-model="userData.address.city"
          />
          <v-text-field
            placeholder="상세 주소"
            ref="refStreet"
            solo
            :height="formHeight"
            required
            v-model="userData.address.street"
          />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      formHeight: 52,
    };
  },
};
</script>
<style lang="scss">
div.v-list:not(.v-select-list) {
  background: transparent !important;

  .v-list-item {
    padding: 0;

    .v-list-item__content {
      padding: 0;
    }

    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 5px;
      color: $primary-color;

      .asterisk {
        color: $text-red;
      }
    }

    &.email {
      .inner-content {
        display: flex;

        span {
          padding: 15px 6px;
          font-weight: 700;
        }
      }
    }

    .v-input {
      .v-input__slot {
        .v-btn {
          font-weight: 700;
          background-color: $mid-green;
          color: #ffffff;
          font-size: 12px;
          height: 28px;
          margin-right: -10px;
        }
      }
    }

    .v-input {
      & ~ .input-guide {
        display: block;
        font-size: 12px;
        padding: 0 10px 20px;
        margin-top: -5px;
      }

      &.error--text {
        & ~ .input-guide {
          display: none;
        }
      }
    }
  }
}
</style>